import React, { useEffect, useState } from "react";
import { useGlobal } from "../../../../../../resources/setting/global";
import Effects from "../../../../../../resources/fabricjs/Effects";
import SliderInput from "../../../../../../resources/component/general/inputs/SliderInput";
import UtilsObject from "../../../../../../resources/utils/UtilsObject";

const styles = {
  controlls: {
    display: 'block', 
    paddingLeft: 10,
    paddingRight: 10,
    // background: '#eeeeee', 
    // borderRadius: 7,
  }
}

const BoxContrast = (props) => {
  
  // global variables
  const {valGlobal} = useGlobal();
  // filters values
  const [contrast, setContrast] = useState(0);

  // apply filter
  const apply = ( setting ) => {
    new Effects().Contrast( valGlobal.canvas, props.values.index, setting );
  }

  // update this component
  const updateComponents = () => {

    UtilsObject.getActive( valGlobal.canvas ).then( object => {

      if (object.hasOwnProperty('filters') === false) return;      
      object.filters = object.filters || [];
      object.filters.forEach( el => {
        if(el.name === props.values.name){
          // set values
          setContrast(props.values.contrast);
        }
      });

    }).catch(()=>{});

  };

  // binding
  useEffect(() => {
    if(contrast){
      const settings = {
        ...props.values,
        contrast: contrast,
      }
      apply(settings);
    }
  },[contrast]);

  useEffect(() => {
    updateComponents();
  },[]);

  return (
    <div style={styles.controlls}>
      <SliderInput value={contrast} min={-1} max={1} step={0.01} default={0} onChange={(e)=>setContrast(e.value)} isInt={false} decimal={2}/>
    </div>
  );
}
export default BoxContrast;